import React from "react";

export const Divider = ({children,color="blue-300 dark:bg-blue-500"}) => {
  return (
    <React.Fragment>
      <div className={`h-[1px] flex-1 bg-${color}`}></div>
      <p className="text-center w-1/2 font-semibold text-lg">{children}</p>
      <div className={`h-[1px] flex-1 bg-${color}`}></div>
    </React.Fragment>
  );
};
